import { gql, gqlFetch } from '@/service/gql'
import { type SanitizedResult } from '@amzn/amp-gql'

/**
 * Party-session GraphQL — wrap a Firefly cloud queue in a shareable
 * party session, and end it. `createPartySession` returns the session
 * id (`shared-…`) we encode in the QR code's URL.
 *
 * Neither operation has an `@include(if: $isAuthenticated)` field, so
 * the variable would be unused and Firefly rejects the operation — keep
 * the variable list tight.
 */

// language=GraphQL
const createPartySessionMutation = gql(`
  mutation CreatePartySession($queueId: String!) {
    createPartySession(queueId: $queueId) {
      id
      url
      host { id name }
      status
    }
  }
`)

export type CreatePartySessionResult = SanitizedResult<typeof createPartySessionMutation>

export async function createPartySession(queueId: string): Promise<CreatePartySessionResult> {
    return gqlFetch(createPartySessionMutation, { queueId }, { isRetryableError: () => true })
}

// language=GraphQL
const endPartySessionMutation = gql(`
  mutation EndPartySession($id: String!) {
    endPartySession(id: $id) {
      id
      status
    }
  }
`)

export async function endPartySession(id: string): Promise<void> {
    await gqlFetch(endPartySessionMutation, { id }, { isRetryableError: () => false })
}
